'use client';

import { useEffect, useState } from 'react';

interface AboutHeroProps {
  language: 'en' | 'es';
}

const AboutHero = ({ language }: AboutHeroProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const content = {
    en: {
      headline: 'Who We Are',
      subhead: 'A small team. Big results.',
    },
    es: {
      headline: 'Quiénes Somos',
      subhead: 'Un equipo pequeño. Resultados grandes.',
    },
  };

  return (
    <section className="pt-32 pb-12 px-6">
      <div className="max-w-screen-xl mx-auto text-center">
        <div className={`space-y-4 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
          <h1 className="text-5xl md:text-6xl font-bold tracking-tight text-foreground">
            {content[language].headline}
          </h1>
          <p className="text-xl text-muted-foreground">
            {content[language].subhead}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;